// PLEASE DON'T EDIT THIS FROM HERE, USE .env FILES INSTEAD
const TURN_URL = process.env.REACT_APP_TURN_URL;
const TURN_USERNAME = process.env.REACT_APP_TURN_USERNAME;
const TURN_PASSWORD = process.env.REACT_APP_TURN_PASSWORD;

export const buildRTCIceConfig = () => {
  const iceConfiguration = {
    initiator: true,
    trickle: false,
    config: {
      iceServers: [
        {
          urls: TURN_URL,
          username: TURN_USERNAME,
          credential: TURN_PASSWORD,
        },
      ],
    },
  };

  return iceConfiguration;
};
